<template>
  <div>
    <div class="font-inter w- h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">
    <NavbarComponent />
    <div class="mx-8 my-6 ">
      <div class="hr-container space-x-5 mb-6 ">
        <div class="flex items-center justify-between">
          <div class="space-y-3">
            <p class="font-semibold text-bodyText text-[20px] space-x-3">Users</p>
            <p class="text-bodyText text-[14px]">View and manage all users.</p>
          </div>
          <div class="flex gap-4">
            <!-- <button @click="emitOpenCreateProjectModal" class="flex bg-black hover:bg-gray-400 text-primaryLight text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] w-[132px] h-[42px]">
                <img src="@/assets/dashboard/add.svg" alt="User icon" class="h-4">
                Create user
              </button> -->
            <button @click="exportCSV" :disabled="exportingCSV"
              class="flex border border-grayLight hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-6 py-3 space-x-4 items-center rounded-[8px] h-[42px] disabled:opacity-50 disabled:cursor-not-allowed">
              <span v-if="exportingCSV">Exporting...</span>
              <span v-else>Export CSV</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="font-inter p-8" @click="closeDropdown">
      <div class="mb-4 flex gap-4 items-center">
        <div class="relative w-[320px]">
          <input 
            v-model="searchQuery" 
            @input="handleSearch"
            type="text" 
            placeholder="Search users..." 
            class="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-[14px]"
          />
          <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>

        <div class="relative w-[280px]">
          <select 
            v-model="selectedAchievementFilter" 
            @change="handleAchievementFilter"
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-[14px] bg-white cursor-pointer"
          >
            <option :value="null">All Badges</option>
            <option v-for="type in availableBadges" :key="type" :value="type">
              {{ type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="loading" class="flex justify-center items-center py-10">
        <div
        class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryDarkBg"
      ></div>
      </div>
      <div v-else>
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50 text-[12px] rounded-[24px] font-medium">
            <tr>
              <th scope="col" class="px-6 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('name')">
                <div class="flex items-center gap-1">
                  Name
                  <span v-if="sortColumn === 'name'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('role')">
                <div class="flex items-center gap-1">
                  Role
                  <span v-if="sortColumn === 'role'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('phone')">
                <div class="flex items-center gap-1">
                  Phone
                  <span v-if="sortColumn === 'phone'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('active_learning_projects')">
                <div class="flex items-center gap-1">
                  Active LG
                  <span v-if="sortColumn === 'active_learning_projects'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('completed_learning_projects')">
                <div class="flex items-center gap-1">
                  Completed LG
                  <span v-if="sortColumn === 'completed_learning_projects'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('total_learning_projects')">
                <div class="flex items-center gap-1">
                  Total LG
                  <span v-if="sortColumn === 'total_learning_projects'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('date_created')">
                <div class="flex items-center gap-1">
                  Date Created
                  <span v-if="sortColumn === 'date_created'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('comment')">
                <div class="flex items-center gap-1">
                  Comment
                  <span v-if="sortColumn === 'comment'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('subscription')">
                <div class="flex items-center gap-1">
                  Subscription
                  <span v-if="sortColumn === 'subscription'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left cursor-pointer hover:bg-gray-100 select-none" @click="toggleSort('credit')">
                <div class="flex items-center gap-1">
                  Credit
                  <span v-if="sortColumn === 'credit'" class="text-gray-500">
                    <svg v-if="sortDirection === 'asc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M5.293 9.707l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L10 7.414l-3.293 3.293a1 1 0 01-1.414-1.414z"/></svg>
                    <svg v-else-if="sortDirection === 'desc'" class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20"><path d="M14.707 10.293l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 12.586l3.293-3.293a1 1 0 111.414 1.414z"/></svg>
                  </span>
                </div>
              </th>
              <th scope="col" class="px-4 py-3 text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in sortedUsers" :key="user.user_id || user.email"
              class="text-[13px] relative ">
              <td  @click="openSideMenu(user)" class="flex gap-3 px-6 py-4 whitespace-nowrap cursor-pointer">
                <div
                  class="w-[42px] h-[42px] flex items-center justify-center rounded-full text-white font-semibold bg-[#A3DB7D]">
                  {{ getInitials(user.first_name, user.last_name) }}
                </div>

                <div>
                  <p class="font-medium text-gray-900">
                    {{ capitalize(user.first_name) }} {{ capitalize(user.last_name) }}
                  </p>
                  <p class="text-grayDark">{{ user.email }}</p>
                </div>
              </td>
              <td class="py-2 px-4">{{ formatRoles(user.role) }}</td>
              <td class="py-2 px-4">{{ user.phone }}</td>
              <td class="py-2 px-4">{{ user.active_learning_projects || 0 }}</td>
              <td class="py-2 px-4">{{ user.completed_learning_projects || 0 }}</td>
              <td class="py-2 px-4">{{ user.total_learning_projects || 0 }}</td>
              <td class="py-2 px-4">{{ new Date(user.date_created).toLocaleString() }}</td>
              <td class="py-2 px-4">{{ user.comment || '-' }}</td>
              <td class="py-2 px-4">{{ user.subscription_name || '-' }}</td>
              <td class="py-2 px-4">{{ user.current_credits || '-' }}</td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <img src="@/assets/projects/options.svg" alt="Options" @click.stop="toggleDropdown(user.user_id, $event)"
                  class="h-6 cursor-pointer" />
                <div v-if="isDropdownOpen(user.user_id)"
                  class="fixed w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50"
                  :style="dropdownStyle(user.user_id)"
                  @click.stop
                >
                  <button @click.stop="editUser(user.user_id)"
                    class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Edit User</button>
                  <button @click.stop="openRoleModal(user)"
                    class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Manage
                    Role</button>
                  <button @click.stop="openBadgeModal(user)"
                    class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Manage Badges</button>
                  <button @click.stop="openCreditModal(user)"
                    class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Update Credit</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="flex justify-between items-center mt-4 text-[13px]">
          <p @click="prevPage" :disabled="currentPage === 1"
            class="flex items-center gap-2 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            <img src="@/assets/reports/arrow-left.svg" alt="Chevron icon" class="h-4" />
            Previous
          </p>
          <div class="flex gap-2">
            <span v-for="page in totalPages" :key="page" @click="fetchUsers(page)" :class="[
              'px-4 py-2 rounded cursor-pointer',
              currentPage === page ? 'bg-[#EFF4FF] text-grayDark' : 'hover:bg-grayDark hover:text-primaryLight'
            ]">
              {{ page }}
            </span>
          </div>
          <p @click="nextPage" :disabled="currentPage === totalPages"
            class="flex items-center gap-2 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed">
            Next
            <img src="@/assets/reports/arrow-right.svg" alt="Chevron icon" class="h-4" />
          </p>

          <!-- <button @click="prevPage" :disabled="currentPage === 1" class="p-2 bg-gray-300 rounded hover:bg-gray-400">
          Previous
        </button>
        <span>Page {{ currentPage }} of {{ totalPages }}</span>
        <button @click="nextPage" :disabled="currentPage === totalPages" class="p-2 bg-gray-300 rounded hover:bg-gray-400">
          Next
        </button> -->
        </div>
      </div>

      <!-- Role Modal -->
      <div v-if="showRoleModal" class="fixed inset-0 z-50 overflow-auto bg-smoke-light flex"
        @click.self="closeRoleModal">
        <div class="relative p-8 bg-white w-full max-w-md m-auto flex-col flex rounded-lg">
          <h2 class="text-2xl font-bold mb-6">Assign Role to {{ selectedUser.first_name }} {{ selectedUser.last_name }}
          </h2>
          <form @submit.prevent="submitRole">
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700">Select Role</label>
              <select v-model="newRole"
                class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                required>
                <option value="">Select a role</option>
                <option value="manager">Manager</option>
                <option value="talent">Talent</option>
              </select>
            </div>
            <div v-if="newRole === 'manager'" class="mb-4">
              <label class="block text-sm font-medium text-gray-700">Industry</label>
              <input v-model="managerIndustry" type="text"
                class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                required />
            </div>
            <div v-if="newRole === 'talent'" class="mb-4">
              <label class="block text-sm font-medium text-gray-700">Portfolio URL</label>
              <input v-model="portfolioUrl" type="text"
                class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                required />
            </div>
            <div class="flex justify-end">
              <button type="button" class="mr-4 py-2 px-4 bg-gray-500 text-white rounded"
                @click="closeRoleModal">Cancel</button>
              <button type="submit" class="py-2 px-4 bg-blue-500 text-white rounded">Assign Role</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isSideMenuOpen" class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40" @click="closeSideMenu">
  </div>

  <div v-if="isSideMenuOpen"
    class="fixed top-0 right-0 w-[543px] h-full bg-white shadow-lg z-50 transform transition-transform duration-300 text-[14px]">
    <!-- <div > -->
    <div class="space-y-4">
      <div class="py-4 px-4 flex justify-between items-center border-b-[1px] border-grayLight">
        <!-- <h3 class="text-lg font-medium">User Details</h3> -->
        <h3 class="text-lg font-medium">
          {{ sideMenuMode === 'user' ? 'User Details' : sideMenuMode === 'role' ? 'Assign New Role' : sideMenuMode === 'credit' ? 'Update Credit' : 'Manage Badges' }}
        </h3>

        <div class="flex space-x-4 items-center">

          <button v-if="!editMode" @click="openDeleteUserModal" class="">
            <img src="@/assets/users/trash.svg" alt="Options" class="h-4 cursor-pointer" />
          </button>
          <button v-if="!editMode" @click="editMode = true" class="">
            <img src="@/assets/users/edit-2.svg" alt="Options" class="h-4 cursor-pointer" />
          </button>
          <div @click="closeSideMenu" class="bg-[#FAFBFC] w-8 h-8 rounded-full flex items-center justify-center">
            <img src="@/assets/tasks/iconoir_cancel.svg" alt="Options" class="h-4 cursor-pointer" />
          </div>
        </div>
      </div>
      <!-- <hr class="w-full border-t border-grayLight rounded-full"> -->
    </div>
    <div v-if="sideMenuMode === 'user'" class="px-5 py-4 space-y-4 text-grayDark text-[13px]">
      <div class="space-y-3">
        <div class="flex space-x-[68px] item-center">
          <div class="flex gap-4">
            <div class="flex space-x-[68px] item-center">
              <div v-if="editMode">
                <p>First name</p>
                <input type="first_name" v-model="selectedUser.first_name"
                  class="mt-1 block w-[244px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" />
              </div>
            </div>
            <div class="flex space-x-[68px] item-center">
              <div v-if="editMode">
                <p>Last name</p>
                <input type="last_name" v-model="selectedUser.last_name"
                  class="mt-1 block w-[244px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" />
              </div>
            </div>
          </div>

        </div>
        <div v-if="!editMode" class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>First name</p>
          </div>
          <span class="">{{ selectedUser?.first_name }}</span>
        </div>

        <div v-if="!editMode" class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>Last name</p>
          </div>
          <span class="">{{ selectedUser?.last_name }}</span>
        </div>
        <div class="flex space-x-[68px] item-center">
          <div v-if="!editMode" class="flex w-[88px] space-x-[124px] items-center">
            <p>Email</p>
            <span>{{ selectedUser?.email }}</span>
          </div>
          <div v-else>
            <p>Email</p>
            <input type="email" v-model="selectedUser.email"
              class="mt-1 block w-[503px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" />
          </div>
        </div>

        <div class="flex space-x-[68px] item-center">
          <div v-if="!editMode" class="flex w-[88px] space-x-2 items-center">
            <p>Phone</p>
            <span>{{ selectedUser?.phone }}</span>
          </div>
          <div v-else>
            <p>Phone</p>
            <input type="phone" v-model="selectedUser.phone"
              class="mt-1 block w-[503px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" />
          </div>
        </div>

        <div class="flex space-x-[68px] item-center">
          <div v-if="!editMode" class="flex w-[88px] space-x-32 justify-between items-center">
            <p>Role</p>
            <div class="flex gap-2">
              <button v-for="(role, index) in selectedUser?.role" :key="index"
                class="bg-gray-200 px-3 py-1 rounded-md text-[12px] font-medium text-gray-700">
                {{ role.charAt(0).toUpperCase() + role.slice(1) }}
              </button>
            </div>
            <!-- <span>{{ selectedUser?.role }}</span> -->
          </div>
          <!-- <div class="space-y-2" v-else >
                <p>Role</p>
                <select 
                  v-model="selectedUser.role"
                  class="mt-1 block w-[503px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]">
                  <option value="admin">Admin</option>
                  <option value="manager">Manager</option>
                  <option value="talent">Talent</option>
                  <option value="user">User</option>
                </select>
                <div class="flex gap-2">
                  <button 
                    v-for="(role, index) in selectedUser?.role" 
                    :key="index" 
                    class="bg-gray-200 px-4 py-2 rounded-md text-sm font-medium text-gray-700"
                  >
                    {{ role.charAt(0).toUpperCase() + role.slice(1) }}
                  </button>
                </div>
              </div> -->
        </div>
        <!-- <div class="flex space-x-[68px] item-center">
              <div v-if="!editMode" class="flex w-[88px] space-x-2 items-center">
                <p>Role</p>
                <div class="flex gap-2">
                  <button 
                    v-for="(role, index) in selectedUser?.role" 
                    :key="index" 
                    class="bg-gray-200 px-4 py-2 rounded-md text-sm font-medium text-gray-700"
                  >
                    {{ role.charAt(0).toUpperCase() + role.slice(1) }}
                  </button>
                </div>
              </div>
            </div> -->


        <div class="flex space-x-[68px] item-center">
          <div v-if="!editMode" class="flex w-[88px] space-x-2 items-center">
            <p>Superuser</p>
            <span>{{ selectedUser?.is_superuser }}</span>
          </div>
          <div v-else>
            <p>Superuser</p>
            <input type="is_superuser" v-model="selectedUser.is_superuser"
              class="mt-1 block w-[503px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" />
          </div>
        </div>

        <div v-if="!editMode" class="flex space-x-[68px] item-center">
          <div class="flex w-[88px] space-x-2 items-center">
            <p>Date Created</p>
          </div>
          <span class="">{{ selectedUser?.date_created }}</span>
        </div>

        <div class="flex space-x-[68px] item-center">
          <div v-if="!editMode" class="flex w-[88px] space-x-2 items-center">
            <p>Comment</p>
            <span>{{ selectedUser?.comment || '-' }}</span>
          </div>
          <div v-else>
            <p>Comment</p>
            <textarea v-model="selectedUser.comment" rows="3" placeholder="Add a comment about this user..."
              class="mt-1 block w-[503px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"></textarea>
          </div>
        </div>
      </div>
      <div class="flex justify-end gap-4">
        <button v-if="editMode" @click="cancelEdit"
          class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
          Cancel
        </button>
        <button v-if="editMode" @click="updateUser"
          class="flex bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
          Save changes
        </button>
      </div>

    </div>

    <!-- Role Management Mode -->
    <div v-else-if="sideMenuMode === 'role'" class="px-5 py-4 space-y-4 text-grayDark text-[13px]">
      <div class="space-y-4">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Role</label>

          <div @click="isRoleExpanded = true"
            class="flex items-center justify-between mt-2 px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-[#F6F8F9] cursor-pointer">
            <!-- Display selected new roles or placeholder text -->
            <div class="flex flex-wrap gap-2">
              <template v-if="selectedRoles.length === 0">
                <span class="text-gray-500">Assign user role</span>
              </template>
              <template v-else>
                <div v-for="role in selectedRoles" :key="role"
                  class="bg-gray-200 px-3 py-1 rounded-full text-[12px] flex items-center gap-1">
                  <span class="text-gray-700">{{ role.charAt(0).toUpperCase() + role.slice(1) }}</span>
                  <!-- X button to remove role -->
                  <button @click.stop="removeRole(role)" class="text-gray-500 hover:text-gray-700 font-medium">
                    ×
                  </button>
                </div>
              </template>
            </div>
            
            <!-- Add button/icon -->
            <span><img src="@/assets/dashboard/add_black.svg" alt="Add Role" class="h-4 w-4" /></span>
          </div>

          <!-- Expanded state - shows checkboxes for roles not already assigned -->
          <div v-if="isRoleExpanded" class="mt-2 p-4 border border-gray-300 rounded-md shadow-sm bg-[#F6F8F9]">
            <div class="mb-2 flex justify-between items-center">
              <span class="font-medium">Assign role to user</span>
              <button @click="isRoleExpanded = false" class="text-gray-500 hover:text-gray-700">
                <span>✕</span>
              </button>
            </div>

            <div v-if="availableNewRoles.length === 0" class="text-gray-500 py-2 text-center">
              All roles have been assigned to this user.
            </div>

            <div v-else class="space-y-2">
              <div v-for="role in availableNewRoles" :key="role"
                class="flex items-center p-2 hover:bg-gray-100 rounded-md">
                <input type="checkbox" :id="'role-' + role" :value="role" v-model="selectedRoles"
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                <label :for="'role-' + role" class="ml-2 text-sm text-gray-700 cursor-pointer">
                  {{ role.charAt(0).toUpperCase() + role.slice(1) }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-4">
  <label class="block text-sm font-medium text-gray-700">Current Role</label>
  <div class="flex gap-2 mt-2">
    <div v-for="(role, index) in selectedUser?.role" :key="index"
      class="bg-gray-200 px-3 py-1 rounded-md text-[12px] font-medium text-gray-700 relative group">
      {{ role.charAt(0).toUpperCase() + role.slice(1) }}
      <!-- X button to remove role -->
      <button @click.stop="openRemoveRoleModal(role)" 
        class="absolute -top-1 -right-1 bg-grayLight text-grayDark rounded-full w-4 h-4 flex items-center justify-center text-[10px] opacity-0 group-hover:opacity-100 transition-opacity">
        ×
      </button>
    </div>
  </div>
</div>

        <!-- <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Current Role</label>
          <div class="flex gap-2 mt-2">
            <button v-for="(role, index) in selectedUser?.role" :key="index"
              class="bg-gray-200 px-3 py-1 rounded-md text-[12px] font-medium text-gray-700">
              {{ role.charAt(0).toUpperCase() + role.slice(1) }}
            </button>
          </div>
        </div> -->

        <div class="flex justify-end gap-4 mt-4">
          <button @click="closeSideMenu"
            class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
            Cancel
          </button>
          <button @click="updateRole"
            class="flex bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
            Save changes
          </button>
        </div>
      </div>
    </div>

    <!-- Badge Management Mode -->
    <div v-else-if="sideMenuMode === 'badge'" class="px-5 py-4 space-y-4 text-grayDark text-[13px]">
      <div class="space-y-4">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Badge</label>
          
          <div @click="isBadgeExpanded = !isBadgeExpanded"
            class="flex items-center justify-between mt-2 px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-[#F6F8F9] cursor-pointer">
            <div class="flex flex-wrap gap-2">
              <template v-if="!selectedBadge">
                <span class="text-gray-500">Select Badge</span>
              </template>
              <template v-else>
                <div class="bg-blue-200 px-3 py-1 rounded-full text-[12px] flex items-center gap-1">
                  <span class="text-gray-700">{{ selectedBadge.replace(/_/g, ' ') }}</span>
                  <button @click.stop="selectedBadge = null; badgeSearchQuery = ''" class="text-gray-500 hover:text-gray-700 font-medium">
                    ×
                  </button>
                </div>
              </template>
            </div>
            
            <span><img :src="isBadgeExpanded ? require('@/assets/tasks/iconoir_cancel.svg') : require('@/assets/dashboard/add_black.svg')" alt="Toggle" class="h-4 w-4" /></span>
          </div>

          <div v-if="isBadgeExpanded" class="mt-2 p-4 border border-gray-300 rounded-md shadow-sm bg-[#F6F8F9]">
            <div class="mb-3 flex justify-between items-center">
              <span class="font-medium">Select badge</span>
              <button @click="isBadgeExpanded = false; badgeSearchQuery = ''" class="text-gray-500 hover:text-gray-700">
                <span>✕</span>
              </button>
            </div>

            <div class="mb-3">
              <div class="relative">
                <input 
                  v-model="badgeSearchQuery" 
                  type="text" 
                  placeholder="Search badges..." 
                  class="w-full px-3 py-2 pl-9 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-[13px] bg-white"
                />
                <svg class="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>

            <div v-if="availableBadges.length === 0" class="text-gray-500 py-2 text-center">
              Loading badges...
            </div>

            <div v-else-if="filteredBadges.length === 0" class="text-gray-500 py-2 text-center">
              No badges match your search.
            </div>

            <div v-else class="space-y-2 max-h-60 overflow-y-auto">
              <div v-for="badge in filteredBadges" :key="badge"
                class="flex items-center p-2 hover:bg-gray-100 rounded-md">
                <input type="radio" :id="'badge-' + badge" :value="badge" v-model="selectedBadge"
                  @change="isBadgeExpanded = false; badgeSearchQuery = ''"
                  class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                <label :for="'badge-' + badge" class="ml-2 text-sm text-gray-700 cursor-pointer capitalize">
                  {{ badge.replace(/_/g, ' ') }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedBadge === 'expert'" class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700">Field *</label>
            <input v-model="achievementName" type="text" placeholder="e.g., Frontend Engineering"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white" />
          </div>
          
          <div>
            <label class="block text-sm font-medium text-gray-700">Description *</label>
            <textarea v-model="achievementDescription" rows="3" placeholder="Describe the achievement..."
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white"></textarea>
          </div>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700">Notes (Optional)</label>
          <textarea v-model="achievementNotes" rows="2" placeholder="Add notes about why this badge is being awarded..."
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white"></textarea>
        </div>

        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700">Current Badges</label>
          <div class="flex gap-2 mt-2 flex-wrap">
            <div v-if="!currentBadges || currentBadges.length === 0" class="text-gray-500 py-2">
              No badges assigned yet.
            </div>
            <div v-else v-for="(badge, index) in currentBadges" :key="index"
              class="bg-blue-200 px-3 py-1 rounded-md text-[12px] font-medium text-gray-700 relative group">
              {{ badge.name }}
              <!-- X button to remove badge -->
              <button @click.stop="openRemoveBadgeModal(badge)" 
                class="absolute -top-1 -right-1 bg-grayLight text-grayDark rounded-full w-4 h-4 flex items-center justify-center text-[10px] opacity-0 group-hover:opacity-100 transition-opacity">
                ×
              </button>
            </div>
          </div>
        </div>

        <div class="flex justify-end gap-4 mt-4">
          <button @click="closeSideMenu"
            class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
            Cancel
          </button>
          <button @click="updateBadges" :disabled="!selectedBadge || (selectedBadge === 'expert' && (!achievementName || !achievementDescription))"
            class="flex bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px] disabled:opacity-50 disabled:cursor-not-allowed">
            Save
          </button>
        </div>
      </div>
    </div>

    <!-- Credit Management Mode -->
    <div v-else-if="sideMenuMode === 'credit'" class="px-5 py-4 space-y-4 text-grayDark text-[13px]">
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700">Current Balance</label>
          <div class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md bg-[#F6F8F9] sm:text-sm">
            {{ selectedUser?.current_credits ?? '-' }}
          </div>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700">Adjust Credits (+ add / - deduct)</label>
          <input v-model.number="creditAdjustment" type="number"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white" />
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700">Reason (Optional)</label>
          <textarea v-model="creditReason" rows="3" placeholder="Why are you adjusting credits?"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-white"></textarea>
        </div>

        <div class="flex justify-end gap-4 mt-4">
          <button @click="closeSideMenu"
            class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
            Cancel
          </button>
          <button @click="updateCredit"
            class="flex bg-primaryDarkBg hover:bg-primaryDark text-white text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
            Save changes
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <DeleteUserModal v-if="isdeleteUserModalOpen" :selectedUser="selectedUser" @close="closeDeleteUserModal"
    @userDeleted="handleUserDeleted" :isdeleteUserModalOpen="openDeleteUserModal" /> -->

  <DeleteUserModal 
    v-if="isdeleteUserModalOpen" 
    :selectedUser="selectedUser" 
    :mode="modalMode"
    :roleToRemove="roleToRemove"
    @close="closeDeleteUserModal"
    @userDeleted="handleUserDeleted" 
    @roleRemoved="handleRoleRemoved"
    @refresh="fetchUsers"
    :isdeleteUserModalOpen="isdeleteUserModalOpen" 
  />
</div>
</template>

<script>
import { reactive } from 'vue';
import apiClient from '@/axios';
import NavbarComponent from '../NavbarComponent.vue';
import DeleteUserModal from '../modals/DeleteUserModal.vue';


export default {
  name: 'UserListComponent',
  components: {
    NavbarComponent,
    DeleteUserModal,
  },
  data() {
    return {
      modalMode: 'user', // 'user' or 'role'
      roleToRemove: '',
      isSideMenuOpen: false,
      sideMenuMode: 'user', // 'user', 'role', or 'badge'
      editMode: false,
      isdeleteUserModalOpen: false,
      isRoleExpanded: false,
      isBadgeExpanded: false,

      // Search
      searchQuery: '',
      searchDebounceTimer: null,

      // Filter
      selectedAchievementFilter: null,

      // Sorting
      sortColumn: null,
      sortDirection: null, // null, 'asc', 'desc'

      // Export
      exportingCSV: false,

      availableRoles: ['manager', 'talent', 'investor'],
      selectedRoles: [],
      availableBadges: [], 
      badgeSearchQuery: '', 
      selectedBadge: null,
      achievementName: '',
      achievementDescription: '',
      achievementNotes: '',
      currentBadges: [], 

      users: [],
      loading: true,
      dropdowns: reactive({}),
      dropdownPositions: reactive({}),
      showRoleModal: false,
      selectedUser: {},
      newRole: '',
      managerIndustry: '',
      portfolioUrl: '',
      creditAdjustment: 0,
      creditReason: '',
      currentPage: 1,
      totalPages: 1,
      pageSize: 10
    };
  },

  computed: {

    availableNewRoles() {
      // Filter out roles that the user already has
      return this.availableRoles.filter(role => {
        return !this.selectedUser?.role || !this.selectedUser.role.includes(role);
      });
    },
    filteredBadges() {
      if (!this.badgeSearchQuery) {
        return this.availableBadges;
      }
      const query = this.badgeSearchQuery.toLowerCase();
      return this.availableBadges.filter(badge => 
        badge.toLowerCase().replace(/_/g, ' ').includes(query)
      );
    },
    sortedUsers() {
      if (!this.sortColumn || !this.sortDirection) {
        return this.users;
      }

      const directionMultiplier = this.sortDirection === 'asc' ? 1 : -1;
      const column = this.sortColumn;

      const getSortValue = (user) => {
        switch (column) {
          case 'name': {
            const first = (user.first_name || '').toString().toLowerCase();
            const last = (user.last_name || '').toString().toLowerCase();
            return `${first} ${last}`.trim();
          }
          case 'role':
            return this.formatRoles(user.role).toLowerCase();
          case 'phone':
            return (user.phone || '').toString();
          case 'active_learning_projects':
            return Number(user.active_learning_projects ?? 0);
          case 'completed_learning_projects':
            return Number(user.completed_learning_projects ?? 0);
          case 'total_learning_projects':
            return Number(user.total_learning_projects ?? 0);
          case 'date_created':
            return new Date(user.date_created);
          case 'comment':
            return (user.comment || '').toString().toLowerCase();
          // The headers use 'subscription'/'credit' but API fields appear to be 'subscription_name'/'current_credits'
          case 'subscription':
            return (user.subscription_name ?? user.subscription ?? '').toString().toLowerCase();
          case 'credit':
            return Number(user.current_credits ?? user.credit ?? 0);
          default:
            return (user[column] ?? '').toString().toLowerCase();
        }
      };

      return [...this.users].sort((a, b) => {
        const aValue = getSortValue(a);
        const bValue = getSortValue(b);

        // Handle Date comparisons explicitly
        if (aValue instanceof Date && bValue instanceof Date) {
          const diff = aValue.getTime() - bValue.getTime();
          return diff === 0 ? 0 : diff * directionMultiplier;
        }

        if (aValue < bValue) return -1 * directionMultiplier;
        if (aValue > bValue) return 1 * directionMultiplier;
        return 0;
      });
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    fullName() {
      if (!this.user || (!this.user.first_name && !this.user.last_name)) {
        return '';
      }
      return `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim();
    },
  },
  methods: {
    dropdownStyle(userId) {
      const pos = this.dropdownPositions[userId];
      if (!pos) {
        return { top: '0px', left: '0px' };
      }
      return { top: `${pos.top}px`, left: `${pos.left}px` };
    },
    formatRoles(roles) {
      if (!Array.isArray(roles) || roles.length === 0) return '-';
      return roles
        .filter(Boolean)
        .map(role => role.toString().charAt(0).toUpperCase() + role.toString().slice(1))
        .join(', ');
    },
    handleSearch() {
      // Debounce search to avoid too many API calls
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.currentPage = 1; // Reset to first page when searching
        this.fetchUsers(1);
      }, 300);
    },

    handleAchievementFilter() {
      this.currentPage = 1; 
      this.fetchUsers(1);
    },

    toggleSort(column) {
      if (this.sortColumn === column) {
        // Cycle through: asc -> desc -> null (reset)
        if (this.sortDirection === 'asc') {
          this.sortDirection = 'desc';
        } else if (this.sortDirection === 'desc') {
          this.sortColumn = null;
          this.sortDirection = null;
        }
      } else {
        // New column selected, start with ascending
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
      this.fetchUsers(this.currentPage);
    },

    removeRole(roleToRemove) {
    // Filter out the role to remove
    this.selectedRoles = this.selectedRoles.filter(role => role !== roleToRemove);
  },
    getInitials(firstName, lastName) {
      const firstInitial = firstName ? firstName.trim().charAt(0).toUpperCase() : '';
      const lastInitial = lastName ? lastName.trim().charAt(0).toUpperCase() : '';
      return `${firstInitial}${lastInitial}`;
    },
    capitalize(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    // openSideMenu(user) {
    //     this.selectedUser = {...user};
    //     this.isSideMenuOpen = true;
    //   },
    // openSideMenu(user) {
    //   this.selectedUser = { ...user };
    //   this.originalUser = { ...user }; // Save original data
    //   this.isSideMenuOpen = true;

    // },
    closeSideMenu() {
      this.isSideMenuOpen = false;
      this.selectedUser = null;
    },
    // openDeleteUserModal() {
    //   this.selectedUser.email;
    //   this.isdeleteUserModalOpen = true;
    // },
    // closeDeleteUserModal() {
    //   this.isdeleteUserModalOpen = false;
    //   this.confirmationText = '';
    //   this.closeSideMenu()
    // },
      openDeleteUserModal() {
    this.modalMode = 'user';
    this.isdeleteUserModalOpen = true;
  },
  
  openRemoveRoleModal(role) {
    this.modalMode = 'role';
    this.roleToRemove = role;
    this.isdeleteUserModalOpen = true;
  },
    closeDeleteUserModal() {
    this.isdeleteUserModalOpen = false;
    this.confirmationText = '';
    this.modalMode = 'user';
    this.roleToRemove = '';
    this.closeSideMenu();
  },
  
  handleRoleRemoved(message) {
    this.$toast.success(message);
    this.fetchUsers();
  },

    // async deleteUser() {
    //   this.showError = false;
    //   this.errorMessage = '';
    //   try {
    //     await apiClient.delete(`/web/users/${this.selectedUser.user_id}`);
    //     console.log(`User ${this.selectedUser.user_id} deleted successfully.`);
    //     this.showSuccess = true;
    //     this.successMessage = 'User deleted successfully!';
    //     this.$emit('userDeleted', 'User deleted successfully'); // Emit success message
    //     this.$emit('refresh'); // Trigger parent to refresh users
    //     this.$emit('close'); // Close the modal
    //   } catch (error) {
    //     console.error('Error deleting user:', error);
    //   }
    // },
    handleUserDeleted(message) {
      this.$toast.success(message);
      this.fetchUsers();
    },
    async fetchUsers(page = 1) {
      try {
        const params = {
          page: page,
          limit: this.pageSize // Number of users per page
        };

        // Add search parameter if there's a search query
        if (this.searchQuery && this.searchQuery.trim()) {
          params.search = this.searchQuery.trim();
        }

        if (this.selectedAchievementFilter) {
          params.achievement_type = this.selectedAchievementFilter;
        }

        // Add sort parameters if sorting is active
        if (this.sortColumn && this.sortDirection) {
          params.sort_by = this.sortColumn;
          params.sort_order = this.sortDirection;
        }

        const response = await apiClient.get('/web/users', {
          params
        });

        this.users = response.data.data;
        const meta = response.data.meta;

        this.currentPage = meta.current_page;
        this.totalPages = meta.total_pages;
        this.loading = false;
      } catch (error) {
        console.error('Error fetching users:', error);
        this.loading = false;
      }
    },
    async updateUser() {
      try {
        const userId = this.selectedUser.user_id;
        await apiClient.put(`/web/users/${userId}`, {
          first_name: this.selectedUser.first_name,
          last_name: this.selectedUser.last_name,
          email: this.selectedUser.email,
          phone: this.selectedUser.phone,
          role: this.selectedUser.role,
          comment: this.selectedUser.comment,

        });
        this.editMode = false; // Exit edit mode
        // this.closeSideMenu()

        this.$toast.success('User updated successfully');
        this.fetchUsers(); // Refresh user list
      } catch (error) {
        console.error('Error updating user:', error);
      }
    },
    cancelEdit() {
      this.selectedUser = { ...this.originalUser };
      this.editMode = false;
    },
    toggleDropdown(userId, event) {
      Object.keys(this.dropdowns).forEach(key => {
        this.dropdowns[key] = false;
      });

      // Position the menu so it doesn't get clipped/off-screen
      if (event?.currentTarget) {
        const dropdownWidth = 192; // w-48
        const dropdownHeight = 160; // approx for 4 menu items
        const padding = 8;

        const rect = event.currentTarget.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        let left = rect.right - dropdownWidth;
        left = Math.max(padding, Math.min(left, viewportWidth - dropdownWidth - padding));

        const shouldOpenUpward = rect.bottom + dropdownHeight > viewportHeight;
        let top = shouldOpenUpward ? rect.top - dropdownHeight : rect.bottom;
        top = Math.max(padding, Math.min(top, viewportHeight - dropdownHeight - padding));

        this.dropdownPositions[userId] = { top, left };
      }

      this.dropdowns[userId] = !this.dropdowns[userId];
    },
    closeDropdown() {
      Object.keys(this.dropdowns).forEach(key => {
        this.dropdowns[key] = false;
      });
    },
    isDropdownOpen(userId) {
      return !!this.dropdowns[userId];
    },

    openSideMenu(user, mode = 'user') {
      this.selectedUser = { ...user };
      this.originalUser = { ...user };
      this.sideMenuMode = mode;
      this.isSideMenuOpen = true;
      if (mode === 'role') {
        // Initialize selected roles from user's current roles
        // this.selectedRoles = user.role ? [...user.role] : [];
        this.selectedRoles = []; // Start with empty selection

        this.isRoleExpanded = false; // Start collapsed
        this.managerIndustry = '';
        this.portfolioUrl = '';
      } else if (mode === 'badge') {
        this.selectedBadge = null; 
        this.badgeSearchQuery = '';
        this.achievementName = '';
        this.achievementDescription = '';
        this.achievementNotes = '';
        this.currentBadges = [];
        this.isBadgeExpanded = false; 
      } else if (mode === 'credit') {
        this.creditAdjustment = 0;
        this.creditReason = '';
      }
    },

    // Update how you handle edit user option
    editUser(userId) {
      const user = this.users.find(u => u.user_id === userId);
      if (user) {
        this.openSideMenu(user, 'user');
        this.editMode = true;
        this.closeDropdown();
      }
    },

    // Update how you handle manage role option
    openRoleModal(user) {
      this.openSideMenu(user, 'role');
      this.closeDropdown();
    },

    openBadgeModal(user) {
      this.openSideMenu(user, 'badge');
      this.fetchCurrentBadges(); 
      this.closeDropdown();
    },

    openCreditModal(user) {
      this.openSideMenu(user, 'credit');
      this.closeDropdown();
    },

    async updateCredit() {
      try {
        const userId = this.selectedUser?.user_id;
        const credits = Number(this.creditAdjustment);
        if (!userId) {
          this.$toast.error('User not selected');
          return;
        }
        if (!Number.isFinite(credits) || credits === 0) {
          this.$toast.error('Enter a non-zero credit adjustment');
          return;
        }

        const response = await apiClient.post(`/web/subscriptions/admin/users/${userId}/credits`, {
          credits,
          reason: this.creditReason || undefined,
        });

        const message = response?.data?.message || 'Credit updated successfully';
        this.$toast.success(message);
        this.closeSideMenu();
        this.fetchUsers(this.currentPage);
      } catch (error) {
        console.error('Error updating credit:', error);
        this.$toast.error(error.response?.data?.message || error.response?.data?.detail || 'Failed to update credit');
      }
    },

    async fetchAchievementTypes() {
      try {
        const response = await apiClient.get('/web/achievements/types');
        this.availableBadges = response.data;
      } catch (error) {
        console.error('Error fetching achievement types:', error);
        this.$toast.error('Failed to load achievement types');
      }
    },


    async fetchCurrentBadges() {
      try {
        const talentId = this.selectedUser.talent_id;
        
        const badgesResponse = await apiClient.get(`/web/achievements/talent/${talentId}`, {
          params: {
            completed_only: true 
          }
        });
        
        this.currentBadges = badgesResponse.data;
      } catch (error) {
        console.error('Error fetching current badges:', error);
        this.currentBadges = [];
      }
    },

    removeBadge() {
      this.selectedBadge = null;
      this.badgeSearchQuery = '';
      this.achievementName = '';
      this.achievementDescription = '';
    },

    openRemoveBadgeModal(badge) {
      if (confirm(`Are you sure you want to remove the "${badge.name}" achievement from this user?`)) {
        this.removeUserBadge(badge);
      }
    },

    async removeUserBadge(badge) {
      try {

        const talentId = this.selectedUser.talent_id;
        
        await apiClient.delete(`/web/achievements/talent/${talentId}/achievement/${badge.id}`);
        
        this.$toast.success('Badge removed successfully');
        this.fetchCurrentBadges(); 
      } catch (error) {
        console.error('Error removing badge:', error);
        this.$toast.error(error.response?.data?.detail || 'Failed to remove badge');
      }
    },

    async updateBadges() {
      try {
        if (!this.selectedBadge) {
          this.$toast.error('Please select a badge type');
          return;
        }

        const payload = {
          achievement_type: this.selectedBadge,
          notes: this.achievementNotes || undefined
        };

        if (this.selectedBadge === 'expert') {
          if (!this.achievementName || !this.achievementDescription) {
            this.$toast.error('Name and description are required for expert achievements');
            return;
          }
          
          payload.name = this.achievementName;
          payload.description = this.achievementDescription;
          payload.category = this.selectedBadge === 'expert' ? 'goals' : '';
          payload.icon = 'check';
          payload.badge = 'mentor';
          payload.badge_color = '#FF6F00';
          payload.requirement_count = 1;
        }


        const talentId = this.selectedUser.talent_id;

        await apiClient.post(`/web/achievements/admin/award/${talentId}`, payload);

        this.$toast.success('Badge awarded successfully');
        
        this.selectedBadge = null;
        this.badgeSearchQuery = '';
        this.achievementName = '';
        this.achievementDescription = '';
        this.achievementNotes = '';
        
        this.fetchCurrentBadges();
      } catch (error) {
        console.error('Error awarding achievement:', error);
        this.$toast.error(error.response?.data?.detail || 'Failed to award achievement');
      }
    },

    async updateRole() {
      try {
        // Get the newly selected roles (ones that weren't already assigned)
        const newlySelectedRoles = this.selectedRoles.filter(role =>
          !this.selectedUser.role || !this.selectedUser.role.includes(role)
        );

        // Make unique to avoid duplicates
        // const allRoles = [...new Set([...(this.selectedUser.role || []), ...this.selectedRoles])];

        // Loop through newly selected roles and apply them
        for (const role of newlySelectedRoles) {
          if (role === 'manager') {
            await apiClient.post('/web/managers', {
              contact_name: this.selectedUser.first_name + ' ' + this.selectedUser.last_name,
              contact_email: this.selectedUser.email,
              industry: this.managerIndustry || "Not specified"
            });
          } else if (role === 'talent') {
            await apiClient.post('/web/talents', {
              email: this.selectedUser.email,
              position: 'talent',
              portfolio_url: this.portfolioUrl || "Not specified"
            });
          } else if (role === 'investor') {
            await apiClient.post('/web/investors', {
              email: this.selectedUser.email,
              contact_name: this.selectedUser.first_name + ' ' + this.selectedUser.last_name,
              industry: "Investor"
            });
          }
        }

        this.$toast.success('Role updated successfully');
        this.closeSideMenu();
        this.fetchUsers();
      } catch (error) {
        console.error('Error updating role:', error);
        this.$toast.error(`Error updating role: ${error.message}`);
      }
    },
    // Pagination methods
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchUsers(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchUsers(this.currentPage);
      }
    },

    async exportCSV() {
      console.log('Export CSV clicked');
      this.exportingCSV = true;
      
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
          export_csv: true
        };

        if (this.searchQuery && this.searchQuery.trim()) {
          params.search = this.searchQuery.trim();
        }

        if (this.selectedAchievementFilter) {
          params.achievement_type = this.selectedAchievementFilter;
        }

        if (this.sortColumn && this.sortDirection) {
          params.sort_by = this.sortColumn;
          params.sort_order = this.sortDirection;
        }

        const response = await apiClient.get('/web/users', { 
          params,
          responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.href = url;
        link.download = `users_export_${new Date().toISOString().split('T')[0]}.csv`;
        
        document.body.appendChild(link);
        link.click();
        
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        this.$toast.success('CSV exported successfully');
      } catch (error) {
        console.error('Error exporting CSV:', error);
        this.$toast.error('Failed to export CSV');
      } finally {
        this.exportingCSV = false;
      }
    }
  },
  created() {
    this.fetchUsers();
    this.fetchAchievementTypes();
  },
};
</script>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 50;
}

.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  z-index: 60;
}
</style>
